import { MouseEvent } from "react";
import isFunction from "lodash/isFunction";
import { useSkipLinkContext } from "../SkipLinkProvider";

const useSkipLink = () => {
  const { handleFocusMain, handleFocusSidebarNavigation, mainRef, sidebarNavigationRef } = useSkipLinkContext();

  const handleSkipTo = (focusHandler?: () => void) => (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (isFunction(focusHandler)) {
      focusHandler();
    }
  };

  return {
    handleSkipToMainContent: handleSkipTo(handleFocusMain),
    handleSkipToSidebarNavigation: handleSkipTo(handleFocusSidebarNavigation),
    mainRef,
    sidebarNavigationRef,
  };
};

export { useSkipLink };
